import styled from "styled-components";

import { GatsbyImage } from "../../../../../components/GatsbyImage";

export const Root = styled.div.attrs({ as: "section" })`
  display: flex;
  flex-direction: column-reverse;
  padding-top: ${({ theme }) => theme.spacing.spacing_32};
  gap: ${({ theme }) => theme.spacing.spacing_32};

  ${props => props.theme.breakpoints.tablet} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing.spacing_32};
    padding-top: 0;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    gap: ${({ theme }) => theme.spacing.spacing_64};
  }
`;

export const TextWrapper = styled.div`
  align-self: center;
  padding: 0 ${({ theme }) => theme.spacing.spacing_24};
  gap: ${({ theme }) => theme.spacing.spacing_12};
  display: flex;
  flex-direction: column;

  ${props => props.theme.breakpoints.tablet} {
    width: 320px;
    padding: 0;
  }

  ${props => props.theme.breakpoints.desktop} {
    width: 400px;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    width: 500px;
  }
`;

export const Image = styled(GatsbyImage)`
  min-height: 374px;

  ${props => props.theme.breakpoints.tablet} {
    width: 50%;
    min-height: 384px;
  }

  ${props => props.theme.breakpoints.desktop} {
    min-height: 512px;
  }

  ${props => props.theme.breakpoints.desktopLarge} {
    min-height: 720px;
  }
`;
